import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function emailresend(email) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/email/resend/${email}`, options)
        .then(response => {
            let user = jsona.deserialize(response.data);
            return user;
        });
}

export default {
    emailresend
};